module.exports = __webpack_public_path__ + "assets/img/30_783_big.578931d4.jpg";